import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[cpbComponentHost]'
})
export class ComponentHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
